<app-painel-header></app-painel-header>
<div class="painel-wrapper">
  <div class="painel-sidebar">
    <app-painel-sidebar></app-painel-sidebar>
  </div>
  <div class="painel-content">
    <div class="container-fluid"> 
      <router-outlet></router-outlet>	
    </div>
  </div>
</div>